import { Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IMainButtonsProps {
  shareButton?: React.ReactNode;
  scrollToHowItWork(): void;
  shareButtonText?: string;
}

export const MainButtons: React.FC<IMainButtonsProps> = ({ shareButton, shareButtonText, scrollToHowItWork }) => {
  return (
    <div className={styles['container']}>
      {shareButton && <div className={styles['share-button']}>{shareButton}</div>}
      <Button onClick={scrollToHowItWork} theme={shareButtonText ? 'fill_secondary' : 'fill_primary'} size="L">
        Как это работает
      </Button>
    </div>
  );
};

MainButtons.displayName = 'MainButtons';
